import React from 'react';
import { Badge } from 'react-bootstrap';

/**
 * #190823 — Cảnh báo TRƯỚC khi quản lý bấm "Duyệt" một ca chính (ca thu ngân) của nhân viên
 * còn đang tập việc.
 *
 * ⚠️ VIẾT LẠI Ở #190823b (05/09/2026): bản đầu ghi "⚠️ NV tháng đầu · ca chính" — bám mốc 30
 * ngày kể từ `join_date` mà #190609 lượt4 đã bỏ hẳn. Mốc hiện hành là **SỐ CA ĐƯỢC DUYỆT**
 * (chưa đủ số ca). Giữ chữ cũ = badge nói sai thứ hệ thống thật sự đo: NV làm 2 năm nhưng mới 5
 * ca duyệt vẫn bị gọi là "NV tháng đầu", còn NV vào hôm qua đã đủ số ca thì không hiện gì.
 * Lý do sếp đổi mốc: 25/38 NV trên production không có `join_date`.
 *
 * ⚠️ Đây là CẢNH BÁO, KHÔNG phải "sẽ bị chặn". Từ #190609 bước duyệt tay KHÔNG còn ném lỗi —
 * server chỉ ghi AuditLog `APPROVE_NEW_HIRE_CASHIER_SHIFT` + báo Telegram. Vì vậy KHÔNG được
 * khoá nút Duyệt và KHÔNG được dùng chữ "bị từ chối"/"chỉ nhận được ca gãy" ở đây.
 *
 * Ngưỡng LẤY TỪ SERVER (`new_hire_shifts_required`), không ghim cứng số nào ở đây — đổi mốc sau
 * này chỉ sửa đúng 1 hằng số phía server. Bản server cũ chưa có cờ ⇒ `undefined` ⇒ không hiện
 * gì, không vỡ màn hình.
 */
export const buildNewHireCashierBadgeText = (shift) => {
  const done = shift?.new_hire_approved_shift_count;
  const required = shift?.new_hire_shifts_required;
  // Server đã gửi đủ số đo thì nói thẳng con số — quản lý thấy ngay còn thiếu bao nhiêu ca.
  if (Number.isFinite(done) && Number.isFinite(required)) {
    return `⚠️ NV tập việc ${done}/${required} ca duyệt · ca chính`;
  }
  // Server cũ (chỉ có cờ, chưa có số đo): vẫn phải tránh chữ "tháng đầu" đã sai mốc.
  return '⚠️ NV chưa đủ ca tập việc · ca chính';
};

const NewHireCashierBadge = ({ shift, className = '' }) => {
  if (!shift?.new_hire_cashier_shift) return null;

  return (
    <Badge
      bg="warning"
      text="dark"
      className={`small ${className}`.trim()}
      title={
        shift.new_hire_cashier_note ||
        'Nhân viên chưa đủ số ca được duyệt để hết tập việc, mà đây là ca chính (ca thu ngân). Duyệt tay vẫn được, hệ thống sẽ ghi nhận là duyệt ngoại lệ.'
      }
      data-testid="new-hire-cashier-badge"
    >
      {buildNewHireCashierBadgeText(shift)}
    </Badge>
  );
};

export default NewHireCashierBadge;
